import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GetAllAccessRequestsLogsResponse } from '@app/generated-api';
import { getSiteBaseUrl } from '@utility/utility';
import { BehaviorSubject, catchError, filter, tap, throwError } from 'rxjs';

@Injectable({
    providedIn: 'any',
})
export class AccessRequestLogService {
    private http = inject(HttpClient);
    private accessRequestsActiveLoading = false;

    private readonly accessRequests = new BehaviorSubject<GetAllAccessRequestsLogsResponse[] | null>(null);

    getAccessRequestsLogs() {
        if (this.accessRequests.getValue() == null && this.accessRequestsActiveLoading === false) {
            this.accessRequestsActiveLoading = true;
            this.loadData().subscribe();
        }

        return this.accessRequests.pipe(filter(Boolean));
    }

    loadData = () =>
        this.http.get<GetAllAccessRequestsLogsResponse[]>(`${getSiteBaseUrl()}/api/v2/accesslog`).pipe(
            tap((result) => {
                this.accessRequests.next(result);
                this.accessRequestsActiveLoading = false;
            }),
            catchError((error) => {
                this.accessRequestsActiveLoading = false;
                return throwError(() => error);
            })
        );

    reloadAccessRequestsLogs() {
        if (this.accessRequestsActiveLoading === false) {
            this.accessRequestsActiveLoading = true;
            this.loadData().subscribe();
        }

        return this.accessRequests.pipe(filter(Boolean));
    }
}
